<template>
  <div class="site-approval-list-container">
    <Condition ref="condition" :onSearch="onSearch" :loading="loading" :classList="classList" />

    <div class="site-appreval-list-content-container">
      <TableHeadIcons
        style="position: relative"
        :onRefresh="() => onSearch()"
        :size.sync="tableDensity"
        :columns="columns"
      >
        <router-link :to="{ name: 'site_create_type' }">
          <a-button type="primary">创建申请</a-button>
        </router-link>
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="spiderId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="spiderId" slot-scope="text, record, index">
          <a-tooltip>
            <template slot="title"> {{ record.spiderId }} </template>
            <span>
              {{ record.spiderId }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>

        <span slot="spiderName" slot-scope="text, record, index">

          <a-tooltip>
            <template slot="title"> {{ record.spiderName }} </template>
            <span>
              {{ record.spiderName }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>

        </span>


        <span slot="spiderClassId" slot-scope="text, record, index">{{ findClassName(text) }}</span>

        <span slot="examineStatus" slot-scope="text, record, index">
          {{ findExamineName(text) }}
        </span>

        <span slot="action" slot-scope="text, record">
          <!-- 没审核或者已驳回 -->
          <router-link
            :to="{
              name: 'site_create_form',
              query: {
                spiderId: record.spiderId,
                type: spiderType,
                route: 'site_approval_list',
                isApply: true
              }
            }"
            v-if="record.examineStatus != 1"
          >
            <a> 编辑 </a>
          </router-link>

          <!-- 通过 -->
          <router-link
            :to="{
              name: 'site_info',
              query: { spiderId: record.spiderId, type: spiderType, route: 'site_approval_list' }
            }"
            v-if="record.examineStatus === 1"
          >
            <a> 详情 </a>
          </router-link>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
const All_Types = ['news', 'api', 'document', 'wechat']
import Condition from './Condition'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { getApprovalMeNewsListApi, getApprovalMeNoNewsListApi } from '@/api/Site/Approval'

export default {
  components: { Condition },

  data() {
    return {
      conditionStorage: {},
      tableDensity: 'middle',
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },

      tableData: [],
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'left',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '站点Id',
          dataIndex: 'spiderId',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'spiderId' }
        },
        {
          title: '站点名称',
          dataIndex: 'spiderName',
          show: true,
          align: 'left',
                    scopedSlots: { customRender: 'spiderName' }
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassId',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'spiderClassId' }
        },
        {
          title: '审批状态',
          dataIndex: 'examineStatus',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'examineStatus' }
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          show: true,
          align: 'left'
        },
        {
          title: '审核时间',
          dataIndex: 'examineTime',
          show: true,
          align: 'left'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          show: true,
          align: 'left',
          width: 80
        }
      ],
      classList: []
    }
  },

  mounted() {
    this.getSpiderClassInfo()
  },

  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    },

    spiderType() {
      return this.classList.find((c) => c.spiderClassId === this.conditionStorage.spiderClassId)
        ?.type
    }
  },

  methods: {

    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },

    async getTableData() {
      if (!this.conditionStorage.spiderClassId) {
        this.$message.error('请选择站点类型')
        return
      }
      this.loading = true
      const query = {
        ...this.conditionStorage,
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize
      }

      const isNews =
        this.classList.find((c) => c.type === 'news')?.spiderClassId ===
        this.conditionStorage.spiderClassId

      const serviceFunc = isNews ? getApprovalMeNewsListApi : getApprovalMeNoNewsListApi

      const { code, data, msg, extra } = await serviceFunc(query)

      if (code === 200) {
        this.tableData = data
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
      this.loading = false
    },

    onSearch(condition) {
      if (condition) {
        this.conditionStorage = { ...condition }
      }
      this.pagination.current = 1
      this.getTableData()
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getTableData()
    },

    async getSpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code !== 200) {
        this.$message.error(msg)
        return
      }

      this.classList = data.filter((d) => All_Types.includes(d.type))
    },

    findClassName(id) {
      return this.classList.find((d) => d.spiderClassId === id)?.spiderClassName
    },

    findExamineName(status) {
      const switchMap = {
        0: '待审核',
        1: '已通过',
        2: '已驳回',
        3: '已删除'
      }
      return switchMap[status]
    }
  }
}
</script>

<style lang="less" scoped>
.site-approval-list-container {
  width: 100%;
  padding: 16px;

  .site-appreval-list-content-container {
    background: white;
    margin-top: 16px;
    padding: 0 16px;
  }
}
</style>
